module.exports = __webpack_public_path__ + "static/media/oway-logo.04304967.svg";